import { render, staticRenderFns } from "./BtnSave.vue?vue&type=template&id=05795344&"
import script from "./BtnSave.vue?vue&type=script&lang=js&"
export * from "./BtnSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports